import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { defaultLocale, mappedLocales, supportedLocales } from './consts';
import LocaleContext from './context';
export const LocaleProvider = _ref => {
  let {
    children,
    locale
  } = _ref;
  const browserLanguage = supportedLocales.find(l => l === navigator.language);
  const mappedBrowserLanguage = mappedLocales[navigator.language];
  const [customLocale, setCustomLocale] = useState(browserLanguage || mappedBrowserLanguage || defaultLocale);
  const context = useMemo(() => ({
    locale: locale || customLocale,
    setLocale: setCustomLocale
  }), [customLocale, locale]);
  useEffect(() => {
    document.documentElement.lang = locale || customLocale;
  }, [locale, customLocale]);
  return /*#__PURE__*/React.createElement(LocaleContext.Provider, {
    value: context
  }, children);
};
LocaleProvider.propTypes = {
  locale: PropTypes.string
};
//# sourceMappingURL=LocaleProvider.js.map